import { Button, Card, Checkbox, Col, DatePicker, Form, Input, Radio, Row, Select, TimePicker } from "antd";

import { useCreateNotification } from "./index.hook";
import { formItemLayout, inputLayout } from "../../../constants/ApplicationConstants/FormConstants";
import styles from "../index.module.less";
import { General } from "../../../util/General";
import CircularProgressBar from "../../common/CircularProgressBar";
import { NotificationTypeConstants } from "../../../constants/DatabaseConstants/ParkingConstants";
import FormInputRules from "../../../util/FormInputRules";
import Loading from "../../common/Loading";

const CreateNotification = () => {
  const config = useCreateNotification();
  return (
    <Card className="gx-card card--height" title={"Add Messaging "}>
      {config.loading ? (
        <Loading />
      ) : (
        <Form
          className={`${styles["formDiv"]} ${styles["formDivExtended"]}`}
          {...formItemLayout}
          onValuesChange={(changedValues) => {
            const fieldName = Object.keys(changedValues)[0];
            config.form.validateFields([fieldName]);
          }}
          validateTrigger="onBlur"
          colon={false}
          form={config.form}
          onFinish={config.handleSubmit}
          initialValues={{ schedule_type: config.scheduleType }}
        >
          <Form.Item name="notification_type" valuePropName="checked" label="Select Type" rules={[FormInputRules.requiredFieldSelectRule("notification type")]}>
            <Checkbox.Group options={config.notificationEndpointOptions} onChange={config.handleChangeNotificationType} />
          </Form.Item>

          <Form.Item name="selected_user" valuePropName="checked" label="Select User" rules={config.isPUSHSelected ? [FormInputRules.requiredFieldSelectRule("user")] : []}>
            <Checkbox.Group options={config.userOptions} />
          </Form.Item>

          {config.isSMSSelected && (
            <Form.Item {...inputLayout} name="mobile_numbers" label="Mobile Numbers" rules={[FormInputRules.multipleMobileNumberValidation]}>
              <Input.TextArea rows={2} placeholder="Enter mobile numbers separated by commas (e.g., 1234567890,0987654321)" />
            </Form.Item>
          )}

          <Form.Item {...inputLayout} name="notification_id" label="Messaging Set" rules={[FormInputRules.requiredFieldSelectRule("notification set")]}>
            <Select className={`${styles["from-Item-selectDiv"]}`} onChange={config.handleChangeNotification} listHeight={200} showSearch allowClear getPopupContainer={(trigger) => trigger.parentElement} filterOption={General.searchFilterOnSelect}>
              {config?.notificationList
                /* Show notification_type is MESSAGING */
                ?.filter((item: { notification_type: string }) => item?.notification_type !== NotificationTypeConstants.CORE_MODULE)
                ?.map((item) => (
                  <Select.Option key={item.id} value={item.id}>
                    {item?.notification_key ?? ""}
                  </Select.Option>
                ))}
            </Select>
          </Form.Item>

          {config.isMaintenanceSelected && (
            <Form.Item {...inputLayout} name="notification_message" style={{ marginBottom: 0 }} label="Date & Time">
              <Row gutter={50} justify="start" style={{ marginLeft: "-0.5rem" }}>
                <Col span={7}>
                  <Form.Item name="selected_date" rules={[{ validator: config.validateSelectedDate(config.notificationList) }]}>
                    <DatePicker format="DD-MM-YYYY" disabledDate={config.disabledDate} onChange={config.handleDateChange} getPopupContainer={(trigger) => trigger.parentElement || document.body} />
                  </Form.Item>
                </Col>

                <Col span={10}>
                  <Form.Item name="time_range" rules={[{ validator: config.validateTimeRange(config.notificationList) }]}>
                    <TimePicker.RangePicker placeholder={["From", "To"]} use12Hours format="hh:mm a" style={{ width: "100%" }} onChange={config.handleTimeRangeChange} getPopupContainer={(trigger) => trigger.parentElement || document.body} />
                  </Form.Item>
                </Col>
              </Row>
            </Form.Item>
          )}

          <Form.Item {...inputLayout} name="notification_message" label="Text" normalize={General.inputWhiteSpaceRemove} rules={[FormInputRules.requiredFieldInputRule("notification text")]}>
            <Input.TextArea disabled={config.isMaintenanceSelected} name="notification_message" rows={4} placeholder="Prefilled on the basis of Notification set ..." />
          </Form.Item>

          <Form.Item name="schedule_type" valuePropName="checked" label="Publish On" rules={[FormInputRules.requiredFieldSelectRule("schedule type")]}>
            <Radio.Group options={config.scheduleOptions} value={config.scheduleType} onChange={config.handleChangeScheduleType} />
          </Form.Item>

          {config.scheduleType === config.scheduleOptions[1] && (
            <Form.Item {...inputLayout} name="publish_on" label="Publish DateTime" rules={[FormInputRules.requiredFieldSelectRule("date")]}>
              <DatePicker
                showTime={{
                  format: "h:mm a", // 12-hour format
                  use12Hours: true // Use 12-hour clock
                }}
                format="DD-MM-YYYY h:mm a"
                disabledDate={config.disabledDate}
                disabledTime={config.disabledTime}
                getPopupContainer={(trigger) => trigger.parentElement!}
              />
            </Form.Item>
          )}

          <Form.Item className="form-button form-button-pr ">
            <Button className="gx-mb-0 button-gradiant" htmlType="submit" disabled={config.saving || !config?.customerId || !config?.locationId}>
              {config.saving ? <CircularProgressBar /> : "Publish"}
            </Button>
          </Form.Item>

          <Form.Item className="form-button form-button-pr ">
            <Button className="gx-mb-0 button-gradiant" onClick={config.handleBack}>
              Back
            </Button>
          </Form.Item>
        </Form>
      )}
    </Card>
  );
};
export default CreateNotification;
